<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .candidate-tags {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;

    > .tags {
      width: 80%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: utils.in_rem(8px);
      text-wrap: nowrap;
      overflow: hidden;
    }

    > .overflow {
      position: absolute;
      right: 0;
    }
  }

  .floating-ui {
    width: utils.in_rem(161px);
    max-height: utils.in_rem(161px);
    background: colors.get(interfaceWhite);
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: utils.in_rem(8px);

    padding: utils.in_rem(14px);
    border-radius: 20px;
    border: 1.5px solid colors.get(interfaceWhite);
    box-shadow: 0px 4px 20px 0px #00000014;

    text-wrap: nowrap;
  }

  .tooltip-wrapper {
    width: 100%;
  }

  .status-wrapper {
    width: fit-content;
    max-width: 100%;
  }
</style>

<script>
  import OverflowAtom from "@sourcewhale/shared/svelte-design-system/components/atoms/OverflowAtom.svelte";
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import ProfileCardOverflow from "./ProfileCardOverflow.svelte";

  import { candidateTagStore } from "../stores";

  let hidden = $state({});
  let hiddenCount = $derived(Object.values(hidden).filter(Boolean).length);

  candidateTagStore.subscribe((value) => {
    const tagIds = value.map((tag) => tag.id);
    hidden = Object.fromEntries(
      Object.keys(hidden)
        .filter((k) => tagIds.includes(k))
        .map((k) => [k, hidden[k]])
    );
  });

  const makeCallback = (i) => (visible) => {
    hidden = { ...hidden, [i]: !visible };
  };
</script>

<div class="candidate-tags">
  <div class="tags">
    {#each $candidateTagStore as tag}
      <OverflowAtom callback={makeCallback(tag.id)}>
        {#snippet content()}
          <div id="tag-{tag.id}">
            <StatusTag size="medium" kind="neutral">{tag.title}</StatusTag>
          </div>
        {/snippet}
      </OverflowAtom>
    {/each}
  </div>
  {#if hiddenCount > 0}
    <div class="overflow">
      <ProfileCardOverflow count={hiddenCount} kind="neutral">
        <div class="floating-ui" slot="hidden-items">
          {#each $candidateTagStore as tag}
            {#if hidden[tag.id]}
              <span class="tooltip-wrapper">
                <Tooltip
                  placement="top"
                  let:onmouseenter
                  let:onmouseleave
                  let:onblur
                  let:onfocus
                >
                  <span slot="tooltip">{tag.title}</span>
                  <div
                    class="status-wrapper"
                    {onmouseenter}
                    {onmouseleave}
                    {onfocus}
                    {onblur}
                    role="button"
                    tabindex="-1"
                  >
                    <StatusTag size="medium" kind="neutral" truncate={true}>
                      {tag.title}
                    </StatusTag>
                  </div>
                </Tooltip>
              </span>
            {/if}
          {/each}
        </div>
      </ProfileCardOverflow>
    </div>
  {/if}
</div>
